export default __webpack_public_path__ + "assets/images/02b8a2fd7a78272b6d4dab18cedec25a.jpg";